import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DataTmp, groupByComponentName, groupByNameHeading, groupByNameTable } from '../../report-common';
import bodyComponent from './body-component';
import referenceComponent from './reference-component';
@Component({
  name: 'template-one',
  components: {
    'body-component': bodyComponent,
    'reference-component': referenceComponent,
  },
})
export default class templateOne extends Vue {
  @Prop() readonly detailReport: any | undefined;
  @Prop(Boolean) readonly isSelectComponent: any | undefined;
  @Prop(Boolean) readonly isEdit: any | undefined;

  selectedComponent = '';

  dataHeading = {
    data: {
      date: new DataTmp(),
      publisher: new DataTmp(),
      subtitle: new DataTmp(),
      title: new DataTmp(),
      title_image: new DataTmp(),
    },
    component: '',
    arrDocId: [],
  };

  dataTableOfContent = {
    data: {
      table_of_entry: [],
      table_of_section: new DataTmp(),
    },
    component: '',
    arrDocId: [],
  };

  dataBody = [];
  dataReference = {};

  @Watch('detailReport')
  reGenerateHtml() {
    if (this.detailReport) {
      const newObj = groupByComponentName(this.detailReport.components);
      this.dataHeading = groupByNameHeading(newObj?.cover_page);
      this.dataTableOfContent = groupByNameTable(newObj?.table_of_contents);
      this.dataBody = newObj?.body_component;
      this.dataReference = newObj?.Reference;
    }
  }

  @Watch('isSelectComponent')
  watchSelectComponent() {
    if (!this.isSelectComponent) {
      this.selectedComponent = '';
    }
  }

  selectComponent(component: string, arrDocId) {
    if (this.isEdit) return;
    this.selectedComponent = component;
    this.$emit('selectComponent', arrDocId);
  }

  selectBody(component, arrDocId) {
    this.selectedComponent = component;
    this.$emit('selectComponent', arrDocId);
  }
}
